/// Extrai mensagem curta e segura para o usuário final.
/// Nunca devolve HTML/stack de Developer Exception Page.
export function getApiErrorMessage(error, fallback = 'Não foi possível concluir a operação.') {
  const data = error?.response?.data;
  const status = error?.response?.status;

  if (typeof data === 'string') {
    const t = data.trim();
    if (!t) return fallback;
    // Página HTML de erro / stack dump
    if (
      t.startsWith('<') ||
      /Microsoft\.(EntityFrameworkCore|AspNetCore)/i.test(t) ||
      /Npgsql\.PostgresException/i.test(t) ||
      /at\s+[\w.]+\(/i.test(t) ||
      t.length > 400
    ) {
      return mensagemPorStatus(status, fallback);
    }
    return t;
  }

  if (data && typeof data === 'object') {
    const mensagem =
      data.mensagem ||
      data.Mensagem ||
      data.message ||
      data.detail ||
      data.title;

    if (typeof mensagem === 'string' && mensagem.trim()) {
      const t = mensagem.trim();
      if (
        t.startsWith('<') ||
        /Microsoft\.(EntityFrameworkCore|AspNetCore)/i.test(t) ||
        /Npgsql\.PostgresException/i.test(t) ||
        t.length > 400
      ) {
        return mensagemPorStatus(status, fallback);
      }
      return t;
    }

    if (typeof data.error === 'string' && data.error.trim()) {
      const mapped = mensagemPorCodigoErro(data.error.trim());
      if (mapped) return mapped;
    }

    const candidata = data.error;
    if (typeof candidata === 'string' && candidata.trim()) {
      const t = candidata.trim();
      if (
        t.startsWith('<') ||
        /Microsoft\.(EntityFrameworkCore|AspNetCore)/i.test(t) ||
        /Npgsql\.PostgresException/i.test(t) ||
        t.length > 400
      ) {
        return mensagemPorStatus(status, fallback);
      }
      return t;
    }

    if (data.errors && typeof data.errors === 'object') {
      const first = Object.values(data.errors).flat().find(Boolean);
      if (typeof first === 'string' && first.trim() && first.length < 400) {
        return first.trim();
      }
    }
  }

  if (error?.message && !error?.response) {
    // Sem response = rede / CORS / API offline
    if (/Network Error|Failed to fetch|timeout/i.test(error.message)) {
      return 'Não foi possível conectar ao servidor. Verifique a conexão.';
    }
    return error.message.length > 200 ? fallback : error.message;
  }

  return mensagemPorStatus(status, fallback);
}

function mensagemPorCodigoErro(code) {
  const map = {
    limite_pdv: 'Limite de PDVs da licença atingido. Desative outro terminal para ativar este.',
    limite_zenpay: 'Limite de terminais ZenPay atingido. Desative outro terminal ZenPay para ativar este.',
    licenca_bloqueada: 'Licença bloqueada.',
    licenca_indisponivel: 'Não foi possível validar a licença.',
    modulo_bloqueado: 'Recurso não habilitado na licença.',
  };
  return map[code] || null;
}

function mensagemPorStatus(status, fallback) {
  if (status === 401 || status === 403) return 'Sessão expirada ou sem permissão.';
  if (status === 404) return 'Registro não encontrado.';
  if (status === 409) return 'Não foi possível concluir. O registro pode estar em uso em outras partes do sistema.';
  if (status === 413) return 'Arquivo grande demais.';
  if (status >= 500) return 'Erro interno no servidor. Tente novamente ou contate o suporte.';
  return fallback;
}
